<template>
  <div id="app">
    <div v-if="checkingSession" class="session-loading">正在加载...</div>
    <router-view v-else />
  </div>
</template>

<script>
import { state } from './store/session'

export default {
  name: 'App',
  computed: {
    checkingSession () {
      return state.checkingSession
    }
  }
}
</script>

<style>
* {
  box-sizing: border-box;
}

html,
body {
  min-width: 320px;
  min-height: 100%;
  margin: 0;
  background: #f6f8f7;
  font-family: "Noto Sans SC", "Microsoft YaHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

body {
  min-height: 100vh;
}

#app {
  min-height: 100vh;
  color: #18333a;
}

.session-loading {
  display: grid;
  min-height: 100vh;
  place-items: center;
  color: #718486;
  font-size: 14px;
}
</style>
